import React from "react";
import { Button, DialogActions, DialogContent, DialogTitle, Dialog, Stack, CircularProgress } from "@mui/material";
import { userRequest } from "../../auth/requestMethods";


export default function ({ open, setOpen }) {
    const [updating, setUpdating] = React.useState(false)


    function recalculate() {
        setUpdating(true)
        // userRequest().post('/delivery-runs/recalculate')
        // setOpen(false)
    }

    return <Dialog maxWidth="md" TransitionProps={{ onEntered: () => { } }} open={open}>
        <DialogTitle>Update Delivery Runs</DialogTitle>
        <DialogContent dividers sx={{ display: 'flex', textAlign: "center", justifyContent: "center" }}>
            {!!updating && <Stack sx={{ color: 'grey.500' }} ><CircularProgress color="inherit" /></Stack>}
            {!updating && "There are draft delivery runs which might be affected by this change. Recalculate all draft delivery runs?"}
        </DialogContent>
        <DialogActions>
            <Button disabled={updating} onClick={recalculate}>Recalculate</Button>
            <Button disabled={updating} onClick={setOpen}>Skip</Button>
        </DialogActions>
    </Dialog>
}